import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-evermile-logo',
  templateUrl: './evermile-logo.component.svg',
  styleUrls: ['./evermile-logo.component.scss'],
})
export class EvermileLogoComponent {
  @Input() height = 15.53;
  @Input() width = 80;
  @Input() color = '#fff';
}
